// extracted by mini-css-extract-plugin
export default {"AdContainer":"NativeAd_AdContainer__N2t6u"};